import { useContext, useState, useEffect } from "react";
import { MapViewerContext } from "src/contexts/MapViewerContext";
import { useDispatch, useSelector } from "react-redux";
import GeoJSON from "ol/format/GeoJSON";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

import { fromLonLat, toLonLat } from "ol/proj";
import { toStringHDMS } from "ol/coordinate.js";
import EventBus from "src/utils/EventBus";
import Overlay from "ol/Overlay";
import environment from "src/config/environment";

const LayerUnduhWilayah = ({ zIndex = 0, visible = true }) => {
  const { map } = useContext(MapViewerContext);

  const { user: currentUser } = useSelector((state) => state.auth);
  const url_nlp = process.env.PUBLIC_URL + "/batnas.json";
  const url_image = "https://tanahair.indonesia.go.id/demnas/images/";

  const displayFeatureInfo = function (evt) {
    if (!map) return;
    //var viewResolution = /** @type {number} **/ map.getView().getResolution();
    const coordinate = evt.coordinate;

    const [lon, lat] = toLonLat(coordinate);

    let layers = map.getLayers().getArray();

    var idx = 0;
    layers.forEach(function (l, i) {
      // /console.log(l)
      if (l.get("id") === "batnas") {
        //console.log(i)
        idx = i;
      }
    });
    var vectorLayer = layers[idx];
    vectorLayer.getFeatures(evt.pixel).then(function (features) {
      const feature = features.length ? features[0] : undefined;
      const popup = document.getElementById("popup");
      if (feature) {
        console.log(feature);
        const popupContent = document.getElementById("popup-content");
        let penamaan = feature.get("Penamaan");
        const button1 = `<button id="button-1" style="cursor: pointer;" >UNDUH BATNAS_${penamaan}_MSL_v1.1.tif</button>`;
        const button2 = `<button id="button-2" style="cursor: pointer;" >UNDUH BATNAS_${penamaan}_MSL_v1.5.tif</button>`;
        const button3 = `<button id="button-3" style="cursor: pointer;" >UNDUH BATNAS_${penamaan}_MSL_v1.6.tif</button>`;

        const thumb = `<img width="170px" height="190px" src="${url_image}BATNAS_${penamaan}.jpg" />`;

        // Set the inner HTML of the popup content
        var list = [
          "105E-110E_10S-05S",
          "110E-115E_10S-05S",
          "115E-120E_10S-05S",
          "105E-110E_15S-10S",
          "110E-115E_15S-10S",
          "115E-120E_15S-10S",
        ];
        if (!list.includes(penamaan)) {
          popupContent.innerHTML = `<p>Unduh Batnas</p><center>${thumb}<br />${button1}<br /><br />${button2}</center>`;
        } else {
          popupContent.innerHTML = `<p>Unduh Batnas</p><center>${thumb}<br />${button1}<br /><br />${button2} <br /><br />${button3}</center>`;

          const Button3 = document.getElementById("button-3");
          Button3.addEventListener("click", async function (event) {
            Button3.innerHTML = " please wait.. processing..";
            window.location.href = `${environment.api}unduh/batnas?token=${currentUser.accessToken}&filename=BATNAS_${penamaan}_MSL_v1.6.tif`;
            Button3.innerHTML = `UNDUH BATNAS_${penamaan}_MSL_v1.6.tif`;
            return false;
          });
        }
        //BATNAS_110E-115E_15S-10S.jpg
        // Attach an event listener to the button
        const Button1 = document.getElementById("button-1");
        Button1.addEventListener("click", async function (event) {
          Button1.innerHTML = " please wait.. processing..";
          window.location.href = `${environment.api}unduh/batnas?token=${currentUser.accessToken}&filename=BATNAS_${penamaan}_MSL_v1.1.tif`;
          Button1.innerHTML = `UNDUH BATNAS_${penamaan}_MSL_v1.1.tif`;
          return false;
        });

        const Button2 = document.getElementById("button-2");
        Button2.addEventListener("click", async function (event) {
          Button2.innerHTML = " please wait.. processing..";
          window.location.href = `${environment.api}unduh/batnas?token=${currentUser.accessToken}&filename=BATNAS_${penamaan}_MSL_v1.5.tif`;
          Button2.innerHTML = `UNDUH BATNAS_${penamaan}_MSL_v1.5.tif`;
          return false;
        });

        // Show the popup with the attribute information${displayField}:
        //popupContent.innerHTML = setContentInfo(feature);
        //popupOverlay.setPosition(coordinate);
        map.getOverlayById("popup").setPosition(coordinate);
        popup.style.display = "block";
      } else {
        popup.style.display = "none";
        console.log("not found");
      }
    });

    /*
    var wmsSource = vectorLayer.getSource();

    /*
    var url = wmsSource.getFeatureInfoUrl(
      evt.coordinate,
      viewResolution,
      "EPSG:3857",
      { INFO_FORMAT: "application/json" }
      //text/html
    );
    console.log(url);
    /
    var url = wmsSource.getUrl();

    const identifyUrl = `${url}/0/query?where=&text=&objectIds=&time=&geometry=${lon},${lat}&geometryType=esriGeometryPoint&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=pjson`;
    document.body.style.cursor = "progress";
    // Fetch the identify results
    fetch(identifyUrl)
      .then((response) => response.json())
      .then((data) => {
        document.body.style.cursor = "default";
        const popup = document.getElementById("popup");
        //console.log(data);
        if (data.features && data.features.length > 0) {
          const feature = data.features[0]; // Use the first result for simplicity
          const attributes = feature.attributes;
          //const displayField = result.displayFieldName;
          console.log(feature);

          const popupContent = document.getElementById("popup-content");

          const button25K = `<button id="button-25K" style="cursor: pointer;" >UNDUH 25K ${feature.attributes.WADMKK}.zip</button>`;
          const button50K = `<button id="button-50K" style="cursor: pointer;">UNDUH 50K ${feature.attributes.WADMKK}.zip</button>`;

          // Set the inner HTML of the popup content
          popupContent.innerHTML = `<p>Unduh RBI: ${feature.attributes.WADMKK}</p>${button25K} <br /> ${button50K}`;

          // Attach an event listener to the button
          const Button25K = document.getElementById("button-25K");
          Button25K.addEventListener("click", async function (event) {
            Button25K.innerHTML = " please wait.. processing..";
            window.location.href = `${environment.api}unduh/rbi?token=${currentUser.accessToken}&prov=${feature.attributes.WADMPR}&kab=${feature.attributes.WADMKK}&skala=25K`;
            Button25K.innerHTML =
              "UNDUH 25K " + feature.attributes.WADMKK + ".zip";
            return false;
          });

          const Button50K = document.getElementById("button-50K");
          Button50K.addEventListener("click", function (event) {
            Button50K.innerHTML = " please wait.. processing..";
            window.location.href = `${environment.api}unduh/rbi?token=${currentUser.accessToken}&prov=${feature.attributes.WADMPR}&kab=${feature.attributes.WADMKK}&skala=50K`;
            Button50K.innerHTML =
              "UNDUH 50K " + feature.attributes.WADMKK + ".zip";
            return false;
          });

          // Show the popup with the attribute information${displayField}:
          //popupContent.innerHTML = setContentInfo(feature);
          //popupOverlay.setPosition(coordinate);
          map.getOverlayById("popup").setPosition(coordinate);
          popup.style.display = "block";
        } else {
          popup.style.display = "none";
          console.log("not found");
        }
      });
    /*
  var node = document.createElement("div")
              //<Button'DEMNAS_'+ feature.graphic.attributes.NAMOBJ+ '_v1.0.tif" style="margin-left:20px;" >DEMNAS_'+ feature.graphic.attributes.NAMOBJ+ '</a>
              node.innerHTML = '<img width="170px" height="190px" src="' + Config.base_domain + 'images/DEMNAS_' + feature.graphic.attributes.NAMOBJ + '.jpg" />';
              var button = document.createElement('button');
              button.innerHTML = 'UNDUH ' + feature.graphic.attributes.NAMOBJ + '_v1.0.tif';
              button.className = "mt-2 btn btn-success btn-sm ml-3";
              button.setAttribute("style", "font-size: x-small");
              button.onclick = function () {
                //check how many download today?
                button.innerHTML = " please wait.. processing.."
                const requestOptions = {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };
                var random = Math.floor(Math.random() * 3); //0, 1, 2
                var path_daily = api_daily;
                var path_unduh = api_unduh;
                if (random === 0) {
                  path_daily = api_daily;
                  path_unduh = api_unduh;
                } else if (random === 1) {
                  path_daily = api_daily2;
                  path_unduh = api_unduh2;
                } else if (random === 2) {
                  path_daily = api_daily3;
                  path_unduh = api_unduh3;
                }
                //console.log(path_daily);
                fetch(path_daily, requestOptions)
                  .then(async response => {
                    const data = await response.json();

                    //console.log(data);
                    if (data.status === 'ok') {
                      window.location.href = path_unduh + 'DEMNAS_' + feature.graphic.attributes.NAMOBJ + '_v1.0.tif';
                    } else {
                      alert(data.status + "\n" + data.message)
                    }
                    button.innerHTML = 'UNDUH ' + feature.graphic.attributes.NAMOBJ + '_v1.0.tif';
                  });

                return false;
              };
              node.appendChild(button)
              return node;
            }


      */
    /*
    WMS/ Geoserver
    vectorLayer.getFeatures(evt.pixel).then(function (features) {
      console.log(features);
    });
    */
    //layers[idx].setVisible(false);
    /*
    vectorLayer.getFeatures(evt.pixel).then(function (features) {
      console.log(features);
      /*
      if (overlay) map.removeOverlay(overlay);
      const feature = features.length ? features[0] : undefined;
      //const info = document.getElementById('info');
      if (features.length) {
        console.log(feature);
        //info.innerHTML = feature.get('ECO_NAME') + ': ' + feature.get('NNH_NAME');
        var container = document.createElement("div");
        container.className = "ol-popup";
        //container.innerHTML="Halo"
        var closer = document.createElement("span");
        //closer.setAttribute("href", "");
        closer.className = "ol-popup-closer";
        //<a href="#" id="popup-closer" className="ol-popup-closer"></a>
        //<div id="popup-content" ></div>
        container.append(closer);
        var content = document.createElement("div");
        var k = create_content(feature, layer);
        k = k + "<br /> <button>zoom to</button>";
        content.innerHTML = k;
        container.append(content);
        overlay = new Overlay({
          element: container,
          autoPan: true,
          autoPanAnimation: {
            duration: 250,
          },
        });

        closer.addEventListener("click", function () {
          featureSelected.getSource().clear();
          overlay.setPosition(undefined);
          closer.blur();

          return false;
        });
        map.addOverlay(overlay);
        overlay.setPosition(evt.coordinate);
      } else {
        //info.innerHTML = '&nbsp;';
        //console.log("not found")
      }

      if (feature !== selected) {
        if (selected) {
          featureSelected.getSource().removeFeature(selected);
        }
        if (feature) {
          featureSelected.getSource().addFeature(feature);
        }
        selected = feature;
      }
      
    });
      */
  };
  useEffect(() => {
    if (!map) return;
    /*
    Geoserver
    var wmsSource = new ImageWMSSource({
      url: "https://tanahair.indonesia.go.id/geoserver/dashboard/wms",
      params: { LAYERS: "kabupaten" },
      ratio: 1,
      serverType: "geoserver",
      crossOrigin: "anonymous",
    });
    var wmsLayer = new ImageLayer({
      source: wmsSource,
      zIndex: zIndex,
    });
    wmsLayer.set("id", "batas_kabupaten_layer");
    wmsLayer.setVisible(visible);
    map.addLayer(wmsLayer);
    */

    var jsonSource = new VectorSource({
      url: url_nlp,
      format: new GeoJSON(),
    });
    var vectorLayer = new VectorLayer({
      source: jsonSource,
      zIndex: zIndex,
    });
    vectorLayer.set("id", "batnas");
    vectorLayer.set("title", "Batnas");
    map.addLayer(vectorLayer);

    const container = document.getElementById("popup");
    const closer = document.getElementById("popup-closer");

    const popupOverlay = new Overlay({
      id: "popup",
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
      element: container,
      positioning: "bottom-center",
      stopEvent: true,
      // offset: [0, -10],
    });

    map.addOverlay(popupOverlay);

    closer.onclick = function (e) {
      e.preventDefault();
      popupOverlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    map.on("singleclick", function (evt) {
      displayFeatureInfo(evt);
      /*
      const coordinate = evt.coordinate;
      //setIdentify(true);
      //if (identify) {
      const hdms = toStringHDMS(toLonLat(coordinate));
      //var buttonHTML = generate_button();
      // var isi = "<p>You clicked here:</p><code>" + hdms + "</code>";
      content.innerHTML = popupOverlay.setPosition(coordinate);
      //}
      */
    });

    return () => {
      if (map) {
        map.removeLayer(vectorLayer);
      }
    };
  }, [map]);

  useEffect(() => {
    if (!map) return;
    let layers = map.getLayers().getArray();
    //console.log(layers);
    //console.log(layers[5])
    var idx = 0;
    layers.forEach(function (l, i) {
      // /console.log(l)
      if (l.get("id") === "batas_kabupaten_layer") {
        //console.log(i)
        idx = i;
      }
    });
    layers[idx].setVisible(visible);
    //layers[1].setSource(getBasemap());
  }, [visible]);

  return null;
};
export default LayerUnduhWilayah;
